export default class ThemeScripts {
  init() {
    //////////////////
    // Menu
    //////////////////

    const menuBtn = document.getElementById("header-right-menu-mobile");
    const menuTextClosed = document.getElementById("menu-text-closed");
    const menuTextOpen = document.getElementById("menu-text-open");
    const menuBtnClosed = document.getElementById("menu-btn-closed");
    const menuBtnOpen = document.getElementById("menu-btn-open");
    const nav = document.getElementById("outstand-menu");
    // for const scrollStyle see 'Photo Modal' code below

    menuBtn.addEventListener("click", () => {
      const isOpen = menuBtn.getAttribute("aria-expanded") === "true";

      // Toggle button visuals
      menuTextClosed.style.display = isOpen ? "flex" : "none";
      menuTextOpen.style.display = isOpen ? "none" : "flex";
      menuBtnClosed.style.display = isOpen ? "flex" : "none";
      menuBtnOpen.style.display = isOpen ? "none" : "flex";

      // Toggle menu visibility
      nav.classList.toggle("show-mobile-menu", !isOpen);

      // Toggle scroll lock + glass overlay
      if (scrollStyle) {
        scrollStyle.classList.toggle("scroll-total-stop-glass", !isOpen);
      }

      // Track state
      menuBtn.setAttribute("aria-expanded", !isOpen);
    });

    //
    // Close menu when resized from mobile to desktop view
    //
    const DESKTOP_BREAKPOINT = 1024;

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const isOpen = menuBtn.getAttribute("aria-expanded") === "true";

        if (isOpen && window.innerWidth >= DESKTOP_BREAKPOINT) {
          menuTextClosed.style.display = "flex";
          menuTextOpen.style.display = "none";
          menuBtnClosed.style.display = "flex";
          menuBtnOpen.style.display = "none";

          nav.classList.remove("show-mobile-menu");

          if (scrollStyle) {
            scrollStyle.classList.remove("scroll-total-stop-glass");
          }

          menuBtn.setAttribute("aria-expanded", "false");
        }
      }, 150);
    });

    ///////////////////
    // Photo modal
    ///////////////////
    var photoModal = document.getElementById("myPhotoModal");
    var openPhotoModal = document.getElementsByClassName("enlarge-image");
    var closePhotoModal =
      document.getElementsByClassName("close-photo-modal")[0];
    var photoModalImg = document.getElementById("photo-modal-img");
    var photoModalContent = document.getElementsByClassName("modal-content")[0];
    var photoModalCaption = document.getElementById("modal-caption");
    var nextButton = document.getElementsByClassName("next-button")[0];
    var previousButton = document.getElementsByClassName("previous-button")[0];
    var scrollStyle = document.getElementsByClassName("scroll-style")[0];

    var positionElem,
      nextPositionElem,
      nextElem,
      previousPositionElem,
      previousElem;

    function updateCaption(elem) {
      if (photoModalCaption) {
        let captionText = null;
        if (
          elem.parentElement?.nextElementSibling?.classList.contains(
            "ImageGalleryItem__caption",
          )
        ) {
          captionText = elem.parentElement.nextElementSibling.innerHTML;
        }

        if (captionText) {
          photoModalCaption.innerHTML = captionText;
          photoModalContent
            .querySelector(".modal-body")
            .classList.add("includes-caption");

          // Defer layout calculation to ensure caption renders
          requestAnimationFrame(() => {
            const captionHeight = photoModalCaption.offsetHeight;
            const availableHeight = window.innerHeight - captionHeight - 40; // 40px margin
            photoModalImg.style.maxHeight = `${availableHeight}px`;
          });
        } else {
          photoModalCaption.innerHTML = "";
          photoModalContent
            .querySelector(".modal-body")
            .classList.remove("includes-caption");
          photoModalImg.style.maxHeight = "100%";
        }
      }
    }

    function showModal(elem) {
      positionElem = Array.from(openPhotoModal).indexOf(elem);
      nextPositionElem = positionElem + 1;
      previousPositionElem = positionElem - 1;

      nextElem = openPhotoModal[nextPositionElem] || null;
      previousElem = openPhotoModal[previousPositionElem] || null;

      photoModalImg.src = elem.src;
      photoModalImg.alt = elem.alt;
      photoModal.style.display = "flex";
      scrollStyle.classList.add("scroll-total-stop");

      nextButton.classList.toggle("show-next-button", !!nextElem);
      previousButton.classList.toggle("show-previous-button", !!previousElem);

      updateCaption(elem);
    }

    function handleNavigation(direction) {
      let targetElem = direction === "next" ? nextElem : previousElem;

      if (targetElem) {
        photoModalImg.src = targetElem.src;
        photoModalImg.alt = targetElem.alt;
        updateCaption(targetElem);

        positionElem += direction === "next" ? 1 : -1;
        nextElem = openPhotoModal[positionElem + 1] || null;
        previousElem = openPhotoModal[positionElem - 1] || null;

        nextButton.classList.toggle("show-next-button", !!nextElem);
        previousButton.classList.toggle("show-previous-button", !!previousElem);
      }
    }

    if (openPhotoModal) {
      Array.from(openPhotoModal).forEach((elem) => {
        elem.addEventListener("click", () => showModal(elem));
      });
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => handleNavigation("next"));
    }

    if (previousButton) {
      previousButton.addEventListener("click", () =>
        handleNavigation("previous"),
      );
    }

    if (closePhotoModal) {
      closePhotoModal.addEventListener("click", () => {
        positionElem =
          nextPositionElem =
          nextElem =
          previousPositionElem =
          previousElem =
            null;
        photoModal.style.display = "none";
        scrollStyle.classList.remove("scroll-total-stop");
        nextButton.classList.remove("show-next-button");
        previousButton.classList.remove("show-previous-button");
      });
    }

    window.addEventListener("resize", () => {
      if (
        photoModal.style.display === "flex" &&
        photoModalCaption.innerHTML.trim() !== ""
      ) {
        requestAnimationFrame(() => {
          const captionHeight = photoModalCaption.offsetHeight;
          const availableHeight = window.innerHeight - captionHeight - 40;
          photoModalImg.style.maxHeight = `${availableHeight}px`;
        });
      }
    });

    //////////////////////////////
    // View more logos button
    //////////////////////////////
    const viewMoreButton = document.querySelector("[data-view-more]");
    const logosWrapper = document.querySelector("[data-logos]");

    if (viewMoreButton && logosWrapper) {
      viewMoreButton.addEventListener("click", function () {
        logosWrapper.classList.add("is-expanded");
        viewMoreButton.remove();
      });
    }

    //////////////////////////////
    // Lazy loading videos
    //////////////////////////////
    const lazyVideos = document.querySelectorAll("video.lazy-video");

    if (!("IntersectionObserver" in window)) {
      lazyVideos.forEach((video) => {
        video.src = video.dataset.src;
        video.load();
        video.play().catch(() => {});
      });
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const video = entry.target;
            video.src = video.dataset.src;
            video.load();
            video.play().catch(() => {});
            video.classList.remove("lazy-video");
            observer.unobserve(video);
          });
        },
        { rootMargin: "200px 0px" },
      );
      lazyVideos.forEach((video) => observer.observe(video));
    }
  }
}
